// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CredentialGeneratedBySchema = z.enum(['USER','FEATURE_ANALYSIS'] as const);

export type CredentialGeneratedByType = `${z.infer<typeof CredentialGeneratedBySchema>}`

export default CredentialGeneratedBySchema;
